import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../utils/routes";

function Logo() {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate(routes.landing)}
      className="min-w-[60px] min-h-[60px] bg-yellow-600 rounded-md hover:cursor-pointer"
    ></div>
  );
}

export default Logo;
